import React from "react";
import { twMerge } from "tailwind-merge";

const Label = ({ htmlFor, children, className }) => {
  return (
    <label
      htmlFor={htmlFor}
      className={twMerge(
        "mb-1 block text-xs font-medium text-gray-500",
        className
      )}
    >
      {children}
    </label>
  );
};

export default Label;
